/* eslint-disable */
import {AXIOS_INSTANCE, baseURL} from '../../api/axios';

import {AXIOS_INSTANCE_NEFROV} from 'api/axios_nefrov';
import {AXIOS_INSTANCE2} from '../../api/axios_calc';
import {ROUTES} from 'routes/nonfrov/constants';

import {client} from 'App';
import {FROV_SIGN} from 'common/constants';
import i18n from 'i18next';
import Cookies from 'js-cookie';
import {createContext, ReactNode, useContext, useEffect, useState} from 'react';

type Dispatch = (Auth?: string | null) => void;

interface AuthProviderProps {
  children: ReactNode;
  initialState?: string | null;
}

const getLang = (lang: string) => (lang === 'ru' ? 'ru-RU' : 'en');

const AuthContext = createContext<string | null>(null);
const AuthDispatchContext = createContext<Dispatch | null>(null);

const frovsign = Cookies.get(FROV_SIGN);
const tokenName = frovsign === 'nonfrov' ? 'nefrov_access_token' : 'token';

const AuthProvider = ({children}: AuthProviderProps) => {
  // it's a quick demo with useState but you can also have a more complexe state with a useReducer
  const [token, setToken] = useState(Cookies.get('token') || null);
  const [interceptorsInstalled, setInterceptorsInstalled] = useState(false);

  useEffect(() => {
    if (token) Cookies.set(tokenName, token);

    const reqInterceptorId = AXIOS_INSTANCE.interceptors.request.use(config => {
      // const withoutAuth = !!(config.signal as any)?.withoutAuth;
      const withoutAuth = config?.url?.includes('feature-toggles');

      return {
        ...config,
        baseURL: baseURL,
        headers:
          token && !withoutAuth
            ? {
                ...config.headers,
                Authorization: `Bearer ${token}`,
                'Accept-Language': getLang(i18n.language),
              }
            : {...config.headers, 'Accept-Language': getLang(i18n.language)},
      };
    });
    const resInterceptorId = AXIOS_INSTANCE.interceptors.response.use(
      response => {
        return response;
      },
      error => {
        if (error.response?.status === 401) {
          client.cancelQueries();
          client.clear();
          setToken(null);
          Cookies.remove(tokenName);
          Cookies.remove(FROV_SIGN);
        }

        if (error.response?.status === 403) {
          throw new Error(JSON.stringify(error.response.data));
        }
        return error.response;
      }
    );
    const reqInterceptorId2 = AXIOS_INSTANCE2.interceptors.request.use(config => ({
      ...config,
      headers: token
        ? {
            ...config.headers,
            Authorization: `Bearer ${token}`,
            'Accept-Language': getLang(i18n.language),
          }
        : {...config.headers, 'Accept-Language': getLang(i18n.language)},
    }));
    const resInterceptorId2 = AXIOS_INSTANCE2.interceptors.response.use(
      response => {
        return response;
      },
      error => {
        if (error.response?.status === 401) {
          client.cancelQueries();
          client.clear();
          setToken(null);
          Cookies.remove(tokenName);
          Cookies.remove(FROV_SIGN);
        }

        if (error.response?.status === 403) {
          throw new Error(JSON.stringify(error.response.data));
        }
        return error.response;
      }
    );

    const reqInterceptorId3 = AXIOS_INSTANCE_NEFROV.interceptors.request.use(config => ({
      ...config,
      headers: token
        ? {
            ...config.headers,
            Authorization: `Bearer ${token}`,
            'Accept-Language': getLang(i18n.language),
          }
        : {...config.headers, 'Accept-Language': getLang(i18n.language)},
    }));
    const resInterceptorId3 = AXIOS_INSTANCE_NEFROV.interceptors.response.use(
      response => {
        return response;
      },
      error => {
        if (error.response?.status === 401) {
          client.cancelQueries();
          client.clear();
          setToken(null);
          Cookies.remove(tokenName);
          Cookies.remove(FROV_SIGN);
        }

        if (error.response?.status === 403) {
          window.location.pathname = `${ROUTES.ERROR}/${error.response.status}`;
          throw new Error(JSON.stringify(error.response.data));
        }
        return error.response;
      }
    );

    setInterceptorsInstalled(true);

    return () => {
      AXIOS_INSTANCE.interceptors.request.eject(reqInterceptorId);
      AXIOS_INSTANCE.interceptors.response.eject(resInterceptorId);
      AXIOS_INSTANCE2.interceptors.request.eject(reqInterceptorId2);
      AXIOS_INSTANCE2.interceptors.response.eject(resInterceptorId2);
      AXIOS_INSTANCE_NEFROV.interceptors.request.eject(reqInterceptorId3);
      AXIOS_INSTANCE_NEFROV.interceptors.response.eject(resInterceptorId3);

      setInterceptorsInstalled(false);
    };
  }, [token]);

  return (
    <AuthContext.Provider value={token}>
      <AuthDispatchContext.Provider value={setToken}>{interceptorsInstalled && children}</AuthDispatchContext.Provider>
    </AuthContext.Provider>
  );
};

const useAuth = (): string | null => {
  return useContext<string | null>(AuthContext);
};

const useAuthDispatch = (): [Dispatch, Dispatch] => {
  const context = useContext<Dispatch | null>(AuthDispatchContext);

  if (context === null) {
    //
    throw new Error('useAuthDispatch must be used within a AuthProvider');
  }
  const handleLogout = () => {
    context(null);
    client.cancelQueries();
    client.clear();
    Cookies.remove(tokenName);
    Cookies.remove(FROV_SIGN);
    window.location.reload();
  };
  return [context, handleLogout];
};

export {AuthProvider, useAuth, useAuthDispatch};
